import { GetterTree } from 'vuex';
import { DeadlinesState } from '@/store/deadlines/types';
import { RootState } from '@/store/types';
import _ from 'lodash';

const getters : GetterTree<DeadlinesState, RootState> = {
  /**
   * デッドラインIDを使ってデッドライン詳細を取得
   * @param {string} deadilneId デッドラインID
   */
  getDeadlineById: (state: DeadlinesState) => (deadilneId: string) => {
    return _.find(state.deadlines, { id: deadilneId })
  },
};

export default getters;
